import { Button } from "@/components/ui/button";
import { useContactForm } from "@/contexts/ContactFormContext";
import { useFadeInOnScroll } from "@/hooks/useFadeInOnScroll";
import { useContent } from "@/contexts/PageContentContext";
import heroBg from "@/assets/hero-bg-optimized.webp";


const HeroSection = () => {
  const { openContactForm } = useContactForm();
  const { ref, isVisible } = useFadeInOnScroll();
  const t = useContent();

  return (
    <section ref={ref} className="overflow-hidden">
      {/* Mobile: stacked image */}

      <img
        src={heroBg}
        alt="Online retailer showcasing prescription eyewear storefront powered by GoHub"
        fetchPriority="high"
        className="block h-[300px] w-full object-cover md:hidden"
        style={{ objectPosition: '80% center' }}
      />

      {/* Desktop: background overlay layout */}
      <div className="relative hidden min-h-[600px] items-center md:flex lg:min-h-[700px]">
        {/* Real <img> instead of CSS background so the browser discovers the
            LCP asset during HTML parse (faster than bg-image, which requires
            CSS evaluation first). Visual output matches bg-cover bg-center. */}
        <img
          src={heroBg}
          alt="Online retailer showcasing prescription eyewear storefront powered by GoHub"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />

        <div className="container relative z-10 mx-auto py-20">
          <div className="max-w-2xl">
            <h1
              className={`mb-5 text-3xl font-extrabold leading-tight text-foreground sm:text-4xl md:text-5xl fade-in-up ${isVisible ? "visible" : ""}`}
            >
              {t("hero", "title")}
            </h1>
            <p
              className={`mb-6 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg fade-in-up ${isVisible ? "visible" : ""}`}
              style={{ transitionDelay: '0.1s' }}
            >
              GoHub is an eyewear business in a box for online retailers seeking additional revenue and higher AOV. 17K frames and 100+ Brands.<br />12 certified labs. Full Rx fulfillment. No Stock and no optical expertise required.
            </p>
            <p
              className={`mb-8 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl fade-in-up ${isVisible ? "visible" : ""}`}
              style={{ color: 'hsl(var(--primary))', transitionDelay: '0.15s' }}
            >
              {t("hero", "subtitle")}
            </p>
            <Button
              variant="outline"
              size="lg"
              className={`border-foreground bg-transparent text-foreground hover:bg-foreground hover:text-primary-foreground transition-all duration-300 hover:scale-105 active:scale-95 fade-in-up ${isVisible ? "visible" : ""}`}
              style={{ transitionDelay: '0.3s' }}
              onClick={openContactForm}
            >
              {t("hero", "cta")}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile: text content below image */}
      <div className="container mx-auto px-4 py-10 md:hidden">
        <div className="max-w-full">
          <p
              className={`mb-5 text-3xl font-extrabold leading-tight text-foreground fade-in-up ${isVisible ? "visible" : ""}`}
              aria-hidden="true"
          >
            {t("hero", "title")}
          </p>
          <p
            className={`mb-6 text-base leading-relaxed text-muted-foreground fade-in-up ${isVisible ? "visible" : ""}`}
            style={{ transitionDelay: '0.1s' }}
          >
            GoHub is an eyewear business in a box for online retailers seeking additional revenue and higher AOV. 17K frames and 100+ Brands.<br />12 certified labs. Full Rx fulfillment. No Stock and no optical expertise required.
          </p>
          <p
            className={`mb-8 text-3xl font-extrabold leading-tight fade-in-up ${isVisible ? "visible" : ""}`}
            style={{ color: 'hsl(var(--primary))', transitionDelay: '0.15s' }}
          >
            {t("hero", "subtitle")}
          </p>
          <Button
            variant="outline"
            size="lg"
            className={`border-foreground bg-transparent text-foreground hover:bg-foreground hover:text-primary-foreground transition-all duration-300 hover:scale-105 active:scale-95 fade-in-up ${isVisible ? "visible" : ""}`}
            style={{ transitionDelay: '0.3s' }}
            onClick={openContactForm}
          >
            {t("hero", "cta")}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
